export enum PacsAccessRulesKeyEnum {
  // --- Модуль PACS (Пропуска) ---
  // --- Раздел PACS.SECTIONS.PACS ---

  PACS_PACS_ENABLED = 'PACS_PACS_ENABLED',

  // Вкладки
  PACS_PACS_EQUIPMENT_READ = 'PACS_PACS_EQUIPMENT_READ',
  PACS_PACS_EQUIPMENT_WRITE = 'PACS_PACS_EQUIPMENT_WRITE',

  PACS_PACS_EVENT_REPORT_READ = 'PACS_PACS_EVENT_REPORT_READ',

  PACS_PACS_COMING_GOING_READ = 'PACS_PACS_COMING_GOING_READ',

  PACS_PACS_PHOTO_VERIFICATION_READ = 'PACS_PACS_PHOTO_VERIFICATION_READ',

  PACS_PACS_ACCESS_CARD_CONTROL_READ = 'PACS_PACS_ACCESS_CARD_CONTROL_READ',

  PACS_PACS_ACCESS_CARD_READ = 'PACS_PACS_ACCESS_CARD_READ',
  PACS_PACS_ACCESS_CARD_WRITE = 'PACS_PACS_ACCESS_CARD_WRITE',

  PACS_PACS_PASSAGE_TASK_READ = 'PACS_PACS_PASSAGE_TASK_READ',
  PACS_PACS_PASSAGE_TASK_WRITE = 'PACS_PACS_PASSAGE_TASK_WRITE',

  PACS_PACS_PASSAGE_ORDER_READ = 'PACS_PACS_PASSAGE_ORDER_READ',
  PACS_PACS_PASSAGE_ORDER_WRITE = 'PACS_PACS_PASSAGE_ORDER_WRITE',

  PACS_PACS_PASSAGE_ORDER_EMPLOYEE_READ = 'PACS_PACS_PASSAGE_ORDER_EMPLOYEE_READ',
  PACS_PACS_PASSAGE_ORDER_EMPLOYEE_WRITE = 'PACS_PACS_PASSAGE_ORDER_EMPLOYEE_WRITE',

  // Разрешения
  PACS_PACS_OPEN_DOORS = 'PACS_PACS_OPEN_DOORS',
  PACS_PACS_SYNCHRONIZE_CONVERTERS = 'PACS_PACS_SYNCHRONIZE_CONVERTERS',
  PACS_PACS_ACCESS_TO_ALL_ROOMS = 'PACS_PACS_ACCESS_TO_ALL_ROOMS',
  PACS_PACS_EXTERNAL_USER_BLOCK_PACS_ACCESS = 'PACS_PACS_EXTERNAL_USER_BLOCK_PACS_ACCESS'
}
